import moment from "moment";

export const toFiniteExecutionMetricNumber = (value: unknown): number | null => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === "string" && value.trim().length > 0) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  if (value !== null && typeof value === "object" && !Array.isArray(value) && "value" in value) {
    return toFiniteExecutionMetricNumber((value as { value?: unknown }).value);
  }

  return null;
};

export const formatExecutionMetadataPrice = (value: unknown): string => {
  const price = toFiniteExecutionMetricNumber(value);
  if (price === null) {
    return "";
  }

  if (price === 0) {
    return "$0";
  }

  if (Math.abs(price) < 0.0001) {
    return "<$0.0001";
  }

  if (Math.abs(price) < 0.01) {
    return `$${price.toPrecision(2)}`;
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: price < 1 ? 4 : 2,
  }).format(price);
};

export const formatExecutionMetadataLatency = (value: unknown): string => {
  const latencyMs = toFiniteExecutionMetricNumber(value);
  if (latencyMs === null) {
    return "";
  }

  const duration = moment.duration(latencyMs, "milliseconds");
  if (duration.asMinutes() >= 1) {
    return `${Math.floor(duration.asMinutes())}m ${duration.seconds()}s`;
  }

  if (duration.asSeconds() >= 10) {
    return `${Math.round(duration.asSeconds())}s`;
  }

  if (duration.asSeconds() >= 1) {
    return `${duration.asSeconds().toFixed(1)}s`;
  }

  return `${Math.round(duration.asMilliseconds())}ms`;
};

export const formatExecutionMetadataStructuredValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }

  if (value !== null && typeof value === "object" && !Array.isArray(value) && "value" in value) {
    return formatExecutionMetadataStructuredValue((value as { value?: unknown }).value);
  }

  try {
    return JSON.stringify(value);
  } catch {
    return "";
  }
};
